import React from 'react';
import ImageUpload from './ImageUpload';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiTrash2, FiImage } = FiIcons;

const MultiImageManager = ({ 
  images = [], 
  maxImages = 3, 
  onImagesChange, 
  path, 
  label, 
  aspect = 1, 
  idealSize = "800x800" 
}) => {
  const handleUpload = (url, index) => {
    const newImages = [...images];
    newImages[index] = url;
    onImagesChange(newImages.filter(Boolean));
  };

  const removeImage = (index) => {
    const newImages = images.filter((_, i) => i !== index);
    onImagesChange(newImages);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest">{label}</label>
        <span className="text-[9px] font-black text-indigo-400 uppercase tracking-widest bg-indigo-50 px-3 py-1 rounded-full">
          {images.length} / {maxImages} Slots Used
        </span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Existing Images */}
        {images.map((img, idx) => (
          <div key={idx} className="relative group animate-in fade-in zoom-in duration-300 h-48">
            <div className="h-full w-full rounded-[2rem] overflow-hidden border border-slate-100 shadow-sm">
              <img src={img} alt="" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-slate-900/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center backdrop-blur-[2px]">
                <button 
                  type="button" 
                  onClick={() => removeImage(idx)}
                  className="w-12 h-12 bg-red-500 text-white rounded-2xl flex items-center justify-center hover:bg-red-600 transition-all shadow-xl"
                >
                  <SafeIcon icon={FiTrash2} />
                </button>
              </div>
            </div>
            <div className="absolute -top-2 -left-2 w-8 h-8 bg-white border border-slate-100 rounded-xl flex items-center justify-center text-[10px] font-black text-slate-400 shadow-sm">
              {idx + 1}
            </div>
          </div>
        ))}

        {/* Add New Slot */}
        {images.length < maxImages && (
          <div className="h-48">
            <ImageUpload 
              path={path} 
              aspect={aspect} 
              idealSize={idealSize} 
              onUploadComplete={(url) => handleUpload(url, images.length)} 
              currentImage={null}
              height="h-48"
              hideHeader={true}
            />
          </div>
        )}
      </div>

      {images.length === 0 && (
        <div className="py-12 bg-slate-50 rounded-[2rem] border border-dashed border-slate-200 text-center">
          <SafeIcon icon={FiImage} className="text-3xl text-slate-300 mx-auto mb-3" />
          <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">No photos uploaded yet</p>
        </div>
      )}
    </div>
  );
};

export default MultiImageManager;